module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/main-visual_sp-252861850ef518e9d66a4f7135810cbf.png";